<template>
    <div class="animated fadeIn">
    <b-row>
      <b-col md="6" offset-md="3">
        <b-card class="py-4 px-5" footer-class="card-footer-center new-footer" v-if="preferredMethod === 'upload'">
          <b-button size="md" variant="secondary" class="preferred-method" @click="updatePreferredMethod('clone')"  v-if="isSuperAdmin" v-b-tooltip.hover :title="$t('TEMPLATE.CLONE')">
            <i class="fa fa-clone" />
          </b-button>
          <b-form-group :label="$t('COMMON.TITLE')" label-for="normalTitle" class="required">
              <input id="normalTitle"
                type="text" :placeholder="$t('TEMPLATE.ENTER_TITLE')"
                class="form-control"
                :class="{'is-invalid': $v.template.title.$error, 'is-valid': !$v.template.title.$invalid}"
                v-model="template.title"
                @blur="$v.template.title.$touch()">
              <b-form-invalid-feedback v-if="!$v.template.title.required">{{ $t('TEMPLATE.REQ_TITLE') }}</b-form-invalid-feedback>
              <b-form-invalid-feedback v-if="!$v.template.title.valid">Template Name can't allow symbols</b-form-invalid-feedback>
              <b-form-invalid-feedback v-if="!$v.template.title.minLength || !$v.template.title.maxLength">Template Name length should be more than 3 and less than 30 characters</b-form-invalid-feedback>
          </b-form-group>
          <b-form-group label="Brand" label-for="basicText" class="required">
            <b-form-select :plain="true"
                           :options="brandNames"
                           :class="{'is-invalid': $v.template.brand.$error, 'is-valid': !$v.template.brand.$invalid}"
                           v-model="template.brand"
                           @blur="$v.template.brand.$touch()"
                           placeholder="Select a Brand"></b-form-select>
            <b-form-invalid-feedback v-if="!$v.template.brand.required">Brand is required</b-form-invalid-feedback>
          </b-form-group>
          <b-form-group :label="$t('COMMON.DESCRIPTION')" label-for="basicText" >
              <b-form-input id="basicText" type="text" :placeholder="$t('TEMPLATE.ENTER_DESCR')"  v-model="template.description"></b-form-input>
          </b-form-group>
          <label for="dropzone">{{$t('FORMS.UPLOAD_MULTI_FORMS')}}</label>
          <vueDropzone ref="formProcessDropZone"
                      id="dropzone"
                      v-if="canShowDropZone"
                      :options="dropzoneOptions"
                      @vdropzone-file-added="onAddingFile"
                      v-on:vdropzone-sending="sendingEvent"
                      v-on:vdropzone-max-files-exceeded="onExceedingMaxFiles"
                      v-on:vdropzone-success="onSuccess"
                      v-on:vdropzone-removed-file="onRemovingFile"
                      v-on:vdropzone-error='onError'>
          </vueDropzone>
          <p class="text-danger mt-1" v-if="isDropzoneBlank" >{{ $t('TEMPLATE.REQ_FILE') }}</p>
          <div slot="footer">
            <b-button type="submit" size="sm" variant="secondary" class="padding-x-5" :disabled="disableSave" @click="formUpload">
              <i v-if="template.uploading" class="fa fa-spinner fa-spin mr-2" style="font-size:18px"></i><span ref="uploadText">{{ $t('COMMON.SAVE') }}</span>
            </b-button>
          </div>
        </b-card>
        <b-card class="py-4 px-5" footer-class="card-footer-center new-footer" v-if="preferredMethod === 'clone'">
          <b-button size="md" variant="secondary" class="preferred-method" @click="updatePreferredMethod('upload')" v-if="isSuperAdmin" v-b-tooltip.hover :title="$t('COMMON.UPLOAD')">
            <i class="fa fa-upload" />
          </b-button>
          <b-form-group :label="$t('TEMPLATE.SELECT_FROM_ACCOUNT')" label-for="basicText" class="required">
            <b-form-select :plain="true"
                           :options="clone.accounts"
                           v-model="clone.selectedFromAccount"
                           @input="handleAccountChange()"></b-form-select>
          </b-form-group>
          <b-form-group :label="$t('TEMPLATE.TEMPLATE')" label-for="basicText" class="required">
            <b-form-select :plain="true"
                           :options="clone.templates"
                           v-model="clone.selectedTemplate"></b-form-select>
          </b-form-group>
          <b-form-group :label="$t('TEMPLATE.SELECT_TO_ACCOUNT')" label-for="basicText" class="required">
            <b-form-select :plain="true"
                           :options="clone.accounts"
                           v-model="clone.selectedToAccount"></b-form-select>
          </b-form-group>
          <div slot="footer">
            <b-button type="submit" size="sm" variant="secondary" class="padding-x-5" :disabled="disableClone" @click="cloneNewTemplate">{{ $t('COMMON.CLONE') }}</b-button>
          </div>
        </b-card>
      </b-col>
    </b-row>
    </div>
</template>

<script>
import Vue from 'vue'
import { required, maxLength, minLength } from 'vuelidate/lib/validators'
import { mapGetters } from 'vuex'
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.css'
import router from '../../router'

export default {
  name: 'new-template',
  components: { vueDropzone: vue2Dropzone },
  data () {
    return {
      template: {
        title: '',
        description: '',
        accountId: '',
        uploading: false,
        brand: ''
      },
      brands: [],
      isDropzoneBlank: false,
      preferredMethod: 'upload',
      clone: {
        accounts: [],
        templates: [],
        selectedTemplate: null,
        selectedFromAccount: null,
        selectedToAccount: null
      },
      dropzoneOptions: {
        url: `${process.env.API_URL}/template_docs`,
        dictDefaultMessage: this.$t('FORMS.DROP_TEMP_SCANNED'),
        autoProcessQueue: false,
        thumbnailWidth: 100,
        thumbnailHeight: 150,
        maxFilesize: 20,
        maxFiles: 1,
        timeout: 300000,
        acceptedFiles: 'application/pdf, image/*, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel,application/rtf, application/x-rtf, text/rtf, text/richtext, application/msword, application/doc, application/x-soffice',
        headers: { 'Authorization': '' },
        init: function () {
          this.on('addedfile', function (file) {
            file.previewElement.querySelector('.dz-details').style.backgroundColor = '#0b192d'
            var removeButton = document.createElement('div')
            removeButton.className = 'removeFormButton'
            removeButton.style.cssText = 'opacity:1;z-index:1000;position:absolute;top:5px;right:5px;color:white;'
            removeButton.innerHTML = '<i class="fa fa-trash"></i>'
            var _this = this

            removeButton.addEventListener('click', function (e) {
              e.preventDefault()
              e.stopPropagation()

              _this.removeFile(file)
            })

            file.previewElement.appendChild(removeButton)
          })
        }
      }
    }
  },
  computed: {
    ...mapGetters(['idToken', 'accountId', 'isSuperAdmin', 'isAdminRole']),
    canShowDropZone () {
      this.dropzoneOptions.headers['Authorization'] = `Bearer ${this.idToken}`
      return (this.idToken !== '')
    },
    disableSave () {
      return !((this.$v.$invalid && !this.$v.$dirty) || !this.$v.$invalid)
    },
    disableClone () {
      return !(this.clone.selectedToAccount && this.clone.selectedTemplate && this.clone.selectedToAccount)
    },
    brandNames () {
      return this.brands.map(brand => brand.name)
    }
  },
  created () {
    if (this.isSuperAdmin) {
      Vue.axios.get('/admin/accounts', {headers: { Authorization: `Bearer ${this.idToken}` }})
        .then(res => {
          let accounts = res.data.accounts.map(function (account) { return { value: account.id, text: account.name } })
          accounts.unshift({ value: null, text: this.$t('TEMPLATE.SELECT_ACCOUNT') })
          this.clone.accounts = accounts
        })
        .catch(err => {
          if (err.status === 401) {
            Vue.toasted.show(this.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' })
            console.log(this.$t('COMMON.MSG_EXPIRED'))
          }
        })
    }
  },
  mounted () {
    this.fetchBrands()
  },
  methods: {
    fetchBrands () {
      this.loading = true
      Vue.axios.get('/brands').then(res => {
        this.brands = res.data
      })
    },
    onExceedingMaxFiles () {
      Vue.toasted.show(this.$t('COMMON.MSG_TEMP_FILE_LIMIT'), { icon: 'chain-broken', type: 'error' })
    },
    sendingEvent (file, xhr, formData) {
      if (this.template.title) {
        formData.append('title', this.template.title)
      } else {
        formData.append('title', file.name)
      }
      formData.append('account_id', this.accountId)
      formData.append('image', file)
      formData.append('brand', this.template.brand)
    },
    onAddingFile () {
      this.$refs.formProcessDropZone.dropzone.files.length ? this.isDropzoneBlank = false : this.isDropzoneBlank = true
    },
    onError (error) {
      this.$refs.uploadText.innerText = this.$t('COMMON.SAVE')
      this.template.uploading = false
      this.$nextTick(() => { this.$v.$reset() })
      const errorMessage = JSON.parse(error.xhr.response).errors
      Vue.toasted.show((errorMessage), { icon: 'chain-broken', type: 'error' })
    },
    onSuccess () {
      Vue.toasted.show(this.$t('COMMON.MSG_TEMP_NAME_SUCCESS'), { type: 'success' })
      router.push({path: '/templates/list'})
    },
    formUpload: function () {
      if (this.$refs.formProcessDropZone.dropzone.files.length === 1 && this.template.title) {
        var myDropzone = this.$refs.formProcessDropZone.dropzone
        this.uploadStart()
        myDropzone.processQueue()
        myDropzone.on('complete', function (file) {
          myDropzone.removeFile(file)
        })
      } else if (this.$refs.formProcessDropZone.dropzone.files.length > 1) {
        this.$v.template.$touch()
        this.onExceedingMaxFiles()
      } else {
        this.$refs.formProcessDropZone.dropzone.files.length ? this.isDropzoneBlank = false : this.isDropzoneBlank = true
        this.$v.template.$touch()
      }
    },
    uploadStart () {
      this.$refs.uploadText.innerText = this.$t('FORMS.UPLOADING')
      this.template.uploading = true
    },
    onRemovingFile () {
      var myDropzone = this.$refs.formProcessDropZone.dropzone
      myDropzone.files.length ? this.isDropzoneBlank = false : this.isDropzoneBlank = true
      if (myDropzone.getRejectedFiles().length > 0 && myDropzone.getAcceptedFiles().length < myDropzone.options.maxFiles) {
        myDropzone.getRejectedFiles()[0]['status'] = 'queued'
        myDropzone.getRejectedFiles()[0]['previewTemplate']['classList'].remove('dz-error')
        myDropzone.getRejectedFiles()[0]['previewTemplate']['classList'].remove('dz-complete')
        myDropzone.getRejectedFiles()[0]['accepted'] = true
      }
    },
    onReset () {
      this.template = { title: '', description: '', file: '' }
      this.$refs.templateFile.reset()
      this.disableButton = false
      this.$nextTick(() => { this.$v.$reset() })
    },
    updatePreferredMethod: function (method) {
      this.preferredMethod = method
    },
    handleAccountChange: function () {
      this.clone.tempates = []
      this.clone.selectedTemplate = null
      Vue.axios.get('/template_docs/list_docs?account_id=' + this.clone.selectedFromAccount, {headers: { Authorization: `Bearer ${this.idToken}` }})
        .then(res => {
          let templateDocs = res.data.template_docs.map(function (template) { return { value: template.id, text: template.title } })
          templateDocs.unshift({ value: null, text: this.$t('TEMPLATE.SELECT_TEMPLATE') })
          this.clone.templates = templateDocs
        })
    },
    cloneNewTemplate: function () {
      let data = {}
      data['template_doc_id'] = this.clone.selectedTemplate
      data['account_id'] = this.clone.selectedToAccount
      Vue.axios.post('/template_docs/clone', data, {headers: { Authorization: `Bearer ${this.idToken}` }})
        .then(res => {
          if (res.data.status === 'success') {
            Vue.toasted.show(res.data.msg)
          } else {
            Vue.toasted.show(res.data.msg, { icon: 'chain-broken', type: 'error' })
          }
        })
    }
  },
  validations: {
    template: {
      title: {
        required,
        maxLength: maxLength(30),
        minLength: minLength(3),
        valid: function (value) {
          const regexExp = /^[a-zA-Z0-9 _-]*$/.test(value)
          return regexExp
        }
      },
      brand: {
        required
      }
    }
  }
}
</script>

<style scoped>
  .dropzone {
    background-color: #eee;
    border: 1px solid #aaa;
    border-radius: .2rem;
  }

  .new-footer {
    background-color: white;
  }

  .preferred-method {
    margin-left: 90%;
    border-radius: 50%;
  }
</style>





// WEBPACK FOOTER //
// src/views/templates/New.vue